import type { BuildingSocietyConfig } from '../ProductsConfig';
import { savings } from './savings-config/base';
import { loan } from './loan-config/base';
import { transactions } from './history-config/base';
import { statements } from './statements-config/base';

export const buildingSociety: BuildingSocietyConfig = {
    transactions,
    defaultRoute: 'overview',
    statements,
    overview: {
        enabled: false,
        list: {
            jointContractHoldersDisplay: false,
        },
    },
    loan,
    dashboard: {
        displayContractNumber: false,
    },
    isNativeAliasChangeAllowed: false,
    savings,
    layout: {
        productInfo: {
            showProductIdentifier: false,
        },
    },
};
